module.exports = __webpack_public_path__ + "static/img/deportes_06.6212c3d0.jpeg";